"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGShieldSvg = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shieldImageWhite = 'https://cdn2.unrealengine.com/eg-shield-logo-white-f8185c103d8d.svg';
const shieldImageBlack = 'https://cdn2.unrealengine.com/eg-shield-logo-black-a93436227177.svg';
const Styled = styled_components_1.default.div `
    height: 36px;
    width: 36px;
    margin: 0 auto;
    display: block;

    svg path {
        transition: fill 0.3s ${(p) => p.theme.easing};
    }

    &.hover {
        &.inline .eg-shield {
            &:hover {
                background: unset;
                path {
                    fill: ${(p) => p.theme.palette.accent.text};
                }
            }
        }
        .eg-shield {
            &:hover {
                background: ${(p) => p.theme.palette.accent.text};
            }
        }
    }

    .eg-shield {
        height: 100%;
        width: 100%;
        transition: background 0.3s ${(p) => p.theme.easing};
        mask: url(${(p) => p.$epicShieldImg});
        display: block;

        &.white {
            mask-size: cover;
            mask-repeat: no-repeat;
            background: #fff;
        }
        &.black {
            mask-size: cover;
            mask-repeat: no-repeat;
            background: #000;
        }
        &.custom {
            mask-size: cover;
            mask-repeat: no-repeat;
            background: #fff;
        }
    }
`;
/**
 * This component has some compressed svgs available for white/black.
 * You can also lean on an inline svg with variant 'inline'
 * Additionally, you can provide a custom img and style it using the custom class
 *
 */
const EGShieldSvg = ({ variant = 'white', label, fill = '#fff', epicShieldImg, hoverStyles = true }) => {
    let el = (react_1.default.createElement("svg", { "aria-label": label, className: "eg-shield", width: "36", height: "36", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 815 815" },
        react_1.default.createElement("path", { fill: fill, 
            // eslint-disable-next-line max-len
            d: "M375.46 252.45v-75.97c0-12.08-5.58-17.69-17.18-17.69h-18.9v111.36h18.9c11.6 0 17.18-5.61 17.18-17.7zm-60.68 270.86l-10.32 25.99h20.51zM685.37 13.5H129.63c-45.04 0-61.67 16.62-61.67 61.69v543.78c0 5.1.21 9.84.66 14.23 1.03 9.84 1.22 19.37 10.37 30.22.89 1.06 10.23 8.01 10.23 8.01 5.02 2.46 8.46 4.28 14.12 6.56l273.65 114.65c14.21 6.51 20.15 9.05 30.46 8.85h0 .04.04 0c10.32.2 16.26-2.33 30.47-8.85l273.65-114.65c5.67-2.28 9.1-4.09 14.12-6.56 0 0 9.34-6.95 10.23-8.01 9.15-10.85 9.34-20.39 10.37-30.22.45-4.39.66-9.13.66-14.23V75.19c.01-45.07-16.62-61.69-61.66-61.69zM442.15 118.22h45.97v302.13h-45.97V118.22zm3.11 375.7h26.77v91.42h-25.21v-52.5l-23.38 35.79h-.52l-23.25-35.52v52.24h-24.82v-91.42h26.77l21.81 35.39 21.83-35.4zm-151.84-375.7h72.16c37.37 0 55.84 18.56 55.84 56.11v80.28c0 37.55-18.47 56.1-55.84 56.1h-26.2v109.63h-45.96V118.22zm-125.27 0h102.23v41.86H214.1v85.46h54.12v41.86H214.1v91.08h57.13v41.86H168.15V118.22zm87.86 454.85c-9.67 7.97-23.12 14.11-39.7 14.11-28.47 0-49.76-19.59-49.76-47.28v-.26c0-26.64 20.9-47.54 49.24-47.54 16.06 0 27.43 4.96 37.09 13.32l-14.89 17.89c-6.53-5.49-13.06-8.62-22.07-8.62-13.19 0-23.38 11.1-23.38 25.08v.26c0 14.76 10.32 25.34 24.82 25.34 6.14 0 10.84-1.31 14.63-3.79v-11.1h-18.02v-18.55h42.06v41.14zm46.76-79.8h24.42l38.92 92.08h-27.17l-6.66-16.33h-35.26l-6.53 16.33h-26.64l38.92-92.08zm102.61 244.55l-128.81-44.28h263.1l-134.29 44.28zm157.56-152.47h-74.18v-91.42h73.53v21.55h-48.46v13.84h43.88v19.98h-43.88v14.5h49.11v21.55zm-50.53-218.52V171.74c0-37.56 18.48-56.11 55.84-56.11h22.34c37.36 0 55.4 18.13 55.4 55.68v61.73h-45.1V173.9c0-12.09-5.59-17.69-17.18-17.69h-7.73c-12.03 0-17.61 5.61-17.61 17.69v190.78c0 12.09 5.59 17.69 17.61 17.69h8.6c11.59 0 17.18-5.61 17.18-17.69v-68.2h45.1v70.35c0 37.56-18.47 56.11-55.84 56.11h-22.77c-37.37 0-55.84-18.56-55.84-56.11zm136.86 190.3c0 18.68-14.76 29.78-36.96 29.78-16.19 0-31.61-5.09-42.84-15.15l14.11-16.85c9.01 7.18 19.07 10.97 29.65 10.97 6.79 0 10.45-2.35 10.45-6.27v-.26c0-3.79-3-5.88-15.41-8.75-19.46-4.44-34.48-9.93-34.48-28.73v-.26c0-16.98 13.45-29.26 35.39-29.26 15.54 0 27.69 4.18 37.61 12.15l-12.67 17.89c-8.36-5.88-17.5-9.01-25.6-9.01-6.14 0-9.14 2.61-9.14 5.88v.26c0 4.18 3.14 6.01 15.8 8.88 21.03 4.57 34.09 11.36 34.09 28.47v.26z" })));
    let image = epicShieldImg;
    if (image) {
        el = react_1.default.createElement("div", { className: "eg-shield custom", "aria-label": label });
    }
    else if (variant === 'black') {
        image = shieldImageBlack;
        el = react_1.default.createElement("div", { className: "eg-shield black", "aria-label": label });
    }
    else if (variant === 'white') {
        image = shieldImageWhite;
        el = react_1.default.createElement("div", { className: "eg-shield white", "aria-label": label });
    }
    return (react_1.default.createElement(Styled, { "$epicShieldImg": image || shieldImageWhite, className: `eg-shield-wrap ${variant} ${hoverStyles ? 'hover' : ''}` }, el));
};
exports.EGShieldSvg = EGShieldSvg;
//# sourceMappingURL=EGShieldSvg.js.map